import { useCommonStore } from '../../stores/commonStore';

interface FullScreenLoadingScreenProps {
    borderColor?: string;
    borderTopColor?: string;
}

const FullScreenLoadingScreen = ({ borderColor = '#D1D5DB', borderTopColor = '#2A55E5' }: FullScreenLoadingScreenProps) => {
    const show = useCommonStore((state) => state.loading);
    if (!show) return null;

    return (
        <div className="z-20 absolute left-0 right-0 top-0 bottom-0 flex justify-center items-center bg-white bg-opacity-70">
            <div className="w-14 h-14 rounded-full border-4 animate-spin" style={{ borderColor, borderTopColor }} />
        </div>
    );
};

export default FullScreenLoadingScreen;
